import React, { Component } from 'react';
import Artist from './Artist';
import Tracks from './Tracks';
import Search from './Search';

class App extends Component {

  state = {
    artist: null,
    tracks: []
  };

  componentDidMount() {
    this.searchArtist('bruno');
  }

  searchArtist = async (artistQuery) => {
    try {

      const artistRes = await fetch(
        `/apps/artists.php?q=${encodeURIComponent(
          artistQuery
        )}&searchType=artist`
      );

      const artistJson = await artistRes.json();

      console.log('ARTIST:', artistJson);

      if (!artistJson?.data?.length) {
        this.setState({
          artist: null,
          tracks: []
        });
        return;
      }

      const artist = artistJson.data[0];

      this.setState({ artist });

      const tracksRes = await fetch(
        `/apps/tracks.php?artistId=${artist.id}`
      );

      const tracksJson = await tracksRes.json();

      console.log('TRACKS:', tracksJson);

      this.setState({
        tracks: tracksJson?.data || []
      });

    } catch (err) {
      console.error('API ERROR:', err);
    }
  };

  searchTrack = async (trackQuery) => {
    try {

      const response = await fetch(
        `/apps/artists.php?q=${encodeURIComponent(
          trackQuery
        )}&searchType=track`
      );

      const json = await response.json();

      console.log('TRACK SEARCH:', json);

      this.setState({
        tracks: json?.data || [],
        artist: null
      });

    } catch (err) {
      console.error('API ERROR:', err);
    }
  };

  render() {

    return (
      <div>
        <h2>Music Master</h2>

        <Search
          searchArtist={this.searchArtist}
          searchTrack={this.searchTrack}
        />

        <Artist artist={this.state.artist} />

        <Tracks tracks={this.state.tracks} />
      </div>
    );
  }
}

export default App;